import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { fetchClearance } from '../../ducks/clearance.duck';
import { ModeType } from '../../interfaces';

export const useClearanceSwap = () => {
  const dispatch = useDispatch();

  const createClearance = useCallback(
    (mode: ModeType) => () => {
      dispatch(fetchClearance(mode));
    },
    [dispatch]
  );

  return {
    createClearance,
  };
};
